module.exports = __webpack_public_path__ + "img/finish-item.5238cb19.png";